



























import { Component, Vue } from 'vue-property-decorator';
import AppModal from '@/components/AppModal.vue';
import AppModalContent from '@/components/AppModalContent.vue';
import AppBtnGroup from '@/components/AppBtnGroup.vue';
import AppBtn from '@/components/AppBtn.vue';
import Mob from '@/models/Mob';
import Trashemon from '@/models/Trashemon';

@Component({
  components: {
    AppModal,
    AppModalContent,
    AppBtnGroup,
    AppBtn
  }
})
export default class StableView extends Vue {
  selectedTrashemonId: string = '';

  get trashemons() {
    return this.$store.getters['game/currentUserTrashemons'];
  }

  selectTrashemon(trashemonId: string) {
    this.selectedTrashemonId = trashemonId;
  }

  confirm() {
    this.$store.dispatch('game/setCurrentTrashemon', this.trashemons.find((t: Trashemon) => t.id === this.selectedTrashemonId));
    this.$router.push({ name: 'Fight', params: { spawnId: this.$route.params.spawnId } });
  }

  xpToLevel(xp: number) {
    return Mob.xpToLevel(xp);
  }
}
